import React, { useState } from 'react'
import styled from 'styled-components'
import ReactMarkdown from 'react-markdown'
import SVG from 'react-inlinesvg'

import Button from '../../components/Button'
import Popup from '../../components/Popup'
//import GalleryThumbs from '../../components/GalleryThumbs'

import AsiaMiles from '../../assets/images/asiamiles.png'
import FD from '../../assets/svg/frequent-diner.svg'

import Masonry from '../Masonry'

import IconFacebook from '../../assets/svg/facebook.svg'
import IconInsta from '../../assets/svg/instagram.svg'

import { bistrochatLinks, bistrochatSlugs } from '../../constants/bistrochat'

const Wrapper = styled.div`
  width: 100%;
  margin: 0 0 80px;

  > svg {
    display: inline-flexl;
    align-items: center;
    justify-ocntent: center;
    width: 120px;
    margin: 0;
  }

  ${({ theme }) => theme.media.l} {
    margin: 0 0 80px 15px;

    > svg {
      width: 220px;
    }
  }

  ${({ theme }) => theme.media.xl} {
    > svg {
      width: 240px;
    }
  }

  ${({ theme }) => theme.media.xxl} {
    > svg {
      width: 280px;
    }
  }
`

const LogoImg = styled.div`
  display: flex;
  width: 140px;
  height: 140px;
  margin: 0;
  align-items: center;

  > img {
    width: 100%;
  }

  ${({ theme }) => theme.media.l} {
    margin: 0 0 0 15px;
    width: 220px;
    height: 220px;
  }

  ${({ theme }) => theme.media.xl} {
    width: 240px;
    height: 240px;
  }

  ${({ theme }) => theme.media.xxl} {
    width: 280px;
    height: 280px;
  }
`

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin: 0;

  > svg {
    width: 50px;
  }

  > div > img {
    height: 30px;
  }

  > div:last-child {
    margin-left: 20px;
  }

  ${({ theme }) => theme.media.l} {
    margin: 0 20px -50px 0;
  }
`

const Description = styled.div`
  position: relative;
  margin: 0 0 50px;

  p {
    line-height: 1.66;
    opacity: 0.9;
    padding-bottom: 25px;
  }

  a {
    color: #a98e67;
    display: inline-block;
    padding-bottom: 25px;
    font-size: 14px;
  }
  

  :before {
    content: '';
    position: absolute;
    top: 5px;
    left: -30px;
    width: 1px;
    height: 60%;
    background: ${({ theme }) => theme.colors.primary};
  }

  ${({ theme }) => theme.media.l} {
    margin: 0 80px 50px 0;
  }
`

const Menu = styled.ul`
  list-style: none;
  margin: 10px 0 50px;
  padding: 0;

  > li {
    position: relative;
    display: inline-block;
    padding: 5px 10px;
    font-size: 14px;
    font-weight: ${({ theme }) => theme.font.bold};
    text-transform: uppercase;
    cursor: pointer;

    :before {
      content: '';
      position: absolute;
      left: 0;
      bottom: -10px;
      width: 100%;
      height: 0;
      background: ${({ theme }) => theme.colors.primary};
      transition: height 0.3s ease;
    }

    :after {
      content: '';
      position: absolute;
      right: 0;
      bottom: 0;
      width: 1px;
      height: 100%;
      background: ${({ theme }) => theme.colors.primary};
      opacity: 0.1;
    }

    :last-child {
      :after {
        display: none;
      }
    }

    :hover:before {
      height: 4px;
    }
  }

  ${({ theme }) => theme.media.l} {
    > li {
      padding: 5px 25px;
      font-size: 18px;
    }
  }
`

const SocialIcons = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  a {
    padding: 11px 3px;
    border: 2px solid rgb(169, 142, 103);
    border-radius: 50px;
    margin-left: 20px;
    svg {
      width: 40px;
      path {
        fill: rgb(169, 142, 103);
      }
    }
  }
`

const ContactInfo = styled.p`
  margin: 0 0 30px;
  color: ${({ theme }) => theme.colors.white};

  span {
    color: ${({ theme }) => theme.colors.primary};
  }

  span,
  strong {
    font-weight: ${({ theme }) => theme.font.bold};
  }

  p {
    margin: 5px 0;
  }
`
const ResHeader = styled.h1`
  font-size: 24px;
  color: rgb(169, 142, 103);
  padding-bottom: 10px;
  font-weight: bold;
  line-height: 1.2;
`

const BarBio = ({ restaurant, name, desc }) => {
  const [menuPopup, setMenuPopup] = useState(false)
  const [galleryPopup, setGalleryPopup] = useState(false)

  const [setActive, setActiveState] = useState("");

  const Icon = ({ filename }) => {
    //console.log(filename); return false; before was retriving from the slug and looking in assets folder!
    //const req = require.context(`../../assets/svg/restaurants`, true, /\.svg$/)
    //const IconTag = req(`./${filename}.svg`)
    const req = require.context(`../../../.cache/gatsby-source-filesystem`, true, /\.svg$/)
    const IconTag = req(`./${filename.base}`)
    return <SVG src={IconTag} />
  }

  function readMore() {
    console.log(restaurant)
    setActiveState(setActive === "" ? "readmore" : "");
  }

  const bistroBook = bistrochatSlugs
  const bistrochat = bistrochatLinks

  return (
    <Wrapper>
      <Header>
        {restaurant.frequentDiner && <SVG src={FD} />}
        {restaurant.asiaMiles && (
          <div>
            <img src={AsiaMiles} alt="Asia Miles logo" />
          </div>
        )}
        <SocialIcons>
          {restaurant.facebook && (
            <a
              href={restaurant.facebook}
              target="_blank"
              rel="noopener noreferrer"
            >
              <SVG src={IconFacebook} />
            </a>
          )}
          {restaurant.instagram && (
            <a
              href={restaurant.instagram}
              target="_blank"
              rel="noopener noreferrer"
            >
              <SVG src={IconInsta} />
            </a>
          )}
        </SocialIcons>
      </Header>
      {restaurant.logo.extension === 'svg' ? (
        <Icon filename={restaurant.logo} />
      ) : (
        <LogoImg>
          <img src={restaurant.logo.childImageSharp.fluid.src} alt={restaurant.Name} />
        </LogoImg>
      )}
      <br />
      { 
        bistroBook.includes(restaurant.slug)
        ?
        (
          <a
            href={bistrochat[restaurant.slug]}
            target="blank"
            rel="noopener noreferrer"
            style={{ display: 'inline-block', marginBottom: '45px' }}
          >
            <Button>Book now</Button>
          </a>
        )
        :
        (
          <a
            href={`https://app.optitable.com/en/reservation/?rid=${restaurant.bookingsId}`}
            target="blank"
            rel="noopener noreferrer"
            style={{ display: 'inline-block', marginBottom: '45px' }}
          >
            <Button>Book now</Button>
          </a>
        )
      }
      {restaurant.fun_order && (
        <a
          href={restaurant.fun_order}
          target="blank"
          rel="noopener noreferrer"
          style={{ display: 'inline-block', marginBottom: '45px', marginLeft: '15px' }}
        >
          <Button>ORDER NOW</Button>
        </a>
      )}
      <Menu>
        <li onClick={() => setMenuPopup(true)}>Menu</li>
        {/*<li onClick={() => setContactPopup(true)}>Contact</li>
        <li onClick={() => setMapPopup(true)}>Map</li>
        <li onClick={() => setSocialPopup(true)}>Get Social</li>*/}
        <li onClick={() => setGalleryPopup(true)}>Gallery</li>
      </Menu>
      <Description>
        <ResHeader>{ restaurant.Name+' - '+restaurant.slogan }</ResHeader>
        {restaurant.phone && (<p>
          <span style={{ fontWeight: 700, color: '#a98e67' }}>Phone: </span>
          <a style={{ fontWeight: 300, color: '#FFF', paddingBottom: '0px', 'font-family': "'josefin_sans',sans-serif", fontSize: '15px' }} href={'tel:'+restaurant.phone}>{restaurant.phone}</a>
        </p>)}
        {restaurant.email && (<p>
          <span style={{ fontWeight: 700, color: '#a98e67' }}>Email: </span>
          <a style={{ fontWeight: 300, color: '#FFF', paddingBottom: '0px', 'font-family': "'josefin_sans',sans-serif", fontSize: '15px' }} href={'mailto:'+restaurant.email}>{restaurant.email}</a>
        </p>)}
        <p>
          <span style={{ fontWeight: 700, color: '#a98e67' }}>Opening Hours: </span><br/>
          <div dangerouslySetInnerHTML={{ __html: restaurant.openingHours }}></div>
        </p>
        <p>
          <span style={{ fontWeight: 700, color: '#a98e67' }}>Address: </span>
          <a style={{ fontWeight: 300, color: '#FFF', paddingBottom: '0px', 'font-family': "'josefin_sans',sans-serif", fontSize: '15px' }} target="_blank" href={restaurant.address_url}>{restaurant.Address}</a>
        </p>
        <ReactMarkdown className={`restaurant-description ${setActive}`} source={desc} />
        <a onClick={ () => readMore()} class={`${setActive}`}><span class={'text-readmore'}>Read More...</span><span class={'text-readless'}>...Read Less</span></a>
      </Description>

      <Masonry
        small
        active={galleryPopup === true}
        handleClose={() => setGalleryPopup(false)}
        images={restaurant.gallery}
      />

      <Popup
        small
        active={menuPopup === true}
        handleClose={() => setMenuPopup(false)}
        type="menu"
      >
        {restaurant.menus[0] ? (
          restaurant.menus.map(item => (
            <div>
            <a
              href={item.file[0].url.replace('diningconcepts','sandshospitality')}
              key={item.file[0].id}
              target="_blank"
              rel="noopener noreferrer"
              class="menu-links"
            >
              {item.fileName}
            </a>
            </div> 
          ))
        ) : (
          <>
            Menu is not avaliable online.
            <br />
            <br />
            {restaurant.facebook && (
              <a href={restaurant.facebook}>Visit facebook page</a>
            )}
          </>
        )}
      </Popup>

    </Wrapper>
  )
}

export default BarBio
